import { defineComponent as _defineComponent } from 'vue'
import BaseButtonV2 from "@/components-UI/buttons/BaseButtonV2.vue";
import SvgDownload from "@/assets/icons/download.svg";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";
import { computed } from "vue";

interface Props {
    loading: boolean;
    disabled?: boolean;
    disableText?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadButton',
  props: {
    loading: { type: Boolean },
    disabled: { type: Boolean },
    disableText: null
  },
  emits: ['click'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
    loading: boolean;
    disabled?: boolean;
    disableText?: string;
}




const isShowTooltip = computed(() => props.disabled && props.disableText);

return { __sfc: true,props, emits, isShowTooltip, BaseButtonV2, SvgDownload, BaseTooltip }
}

})